import { useEffect, useMemo, useState } from "react";
import { IntegrationShell } from "../common/Shell";
import { useOutletContext } from "react-router-dom";
import Plivo from "V2.0/images/plivo.svg";
import Joi from "joi-browser";
import Form from "V2.0/components/Form";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const buttonInfoPlivo = {
  label: "Connect Plivo",
  style: "entire-width",
};

const plivoFields = {
  authId: {
    template: {
      name: "authId",
      label: "Auth Id",
      type: "text",
    },
    schema: Joi.string().max(5000).required().label("Auth Id"),
  },
  authToken: {
    template: {
      name: "authToken",
      label: "Auth Token",
      type: "text",
    },
    schema: Joi.string().max(5000).required().label("Auth Token"),
  },
  // plivoNumber: {
  //   template: {
  //     name: "plivoNumber",
  //     label: "Phone number (prefix country code)",
  //     type: "text",
  //   },
  //   schema: Joi.string()
  //     .regex(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/)
  //     .min(6)

  //     .label("Phone number")
  //     .error((errors) => {
  //       return errors.map((err) => {
  //         if (err.type === "string.min") {
  //           return {
  //             message: "Phone number must be at least 6 characters long.",
  //           };
  //         }
  //         if (err.type === "string.regex.base") {
  //           return { message: "Please enter a valid phone number." };
  //         }
  //         if (err.type === "any.empty") {
  //           return { message: "Phone number is required." };
  //         }
  //         return err;
  //       });
  //     }),
  // },
};

const plivoFieldTemplates = Object.values(plivoFields).map(
  (field) => field.template,
);
const plivoFieldSchema = Object.keys(plivoFields).reduce(
  (schemaAcc, field) => ({ ...schemaAcc, [field]: plivoFields[field].schema }),
  {},
);

export function PlivoIntegration() {
  const {
    projectId,
    thirdpartyData,
    updateThirdpartyData,
    isThirdPartyLoading,
    isViewOnly,
  } = useOutletContext();

  if (isThirdPartyLoading) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <AiOutlineLoading3Quarters className="animate-spin" />
      </div>
    );
  }

  return (
    <IntegrationShell>
      <PlivoComponent
        projectId={projectId}
        plivoSettings={thirdpartyData.telephonySettings.plivoSettings}
        updatePlivoSettings={updateThirdpartyData}
        isViewOnly={isViewOnly}
      />
    </IntegrationShell>
  );
}

function PlivoComponent(props) {
  const { projectId, plivoSettings, updatePlivoSettings, isViewOnly } = props;

  const [plivoFormFields, setPlivoFormFields] = useState({
    authId: "",
    authToken: "",
    // plivoNumber: "",
  });

  const [errorMessage] = useState({});
  const [loading, setLoading] = useState(false);

  const updatedPlivoFieldTemplates = useMemo(() => {
    if (!isViewOnly) {
      return plivoFieldTemplates;
    }

    return plivoFieldTemplates.map((field) => {
      return {
        ...field,
        disabled: isViewOnly,
      };
    });
  }, [isViewOnly]);

  const updatedButtonInfo = !isViewOnly ? buttonInfoPlivo : {};

  useEffect(() => {
    if (plivoSettings) {
      setPlivoFormFields({
        authId: plivoSettings?.authId,
        authToken: plivoSettings?.authToken,
      });
    }
  }, [plivoSettings]);

  const handlePlivoConnect = async (data) => {
    let telephonySettings = {
      telephonySettings: {
        telephonyProvider: "plivo",
        plivoSettings: data,
      },
    };

    const lifecycleCbs = {
      init: () => {
        message.loading("Connecting Plivo");
      },
      success: () => {
        message.destroy();
        setLoading(false);
        message.success("Plivo Connected");
      },
      error: (e) => {
        message.destroy();
        setLoading(false);
        showErrorToast(e, "Failed to connect Plivo");
      },
    };

    updatePlivoSettings(telephonySettings, projectId, lifecycleCbs);
  };

  return (
    <div>
      <div class="flex flex-col items-center">
        <div className="w-full max-w-md p-8 border rounded-lg">
          <div className="flex items-center gap-x-2 mb-4">
            <img
              src={Plivo}
              width={40}
            />
            <h3 className="text-base font-semibold leading-6 text-gray-900">
              Connect Plivo account
            </h3>
          </div>

          <div>
            <Form
              key={JSON.stringify(plivoFormFields)}
              errorMessage={errorMessage}
              inputField={plivoFormFields}
              template={updatedPlivoFieldTemplates}
              schema={plivoFieldSchema}
              buttonInfo={updatedButtonInfo}
              onSubmit={handlePlivoConnect}
              loading={loading}
              setLoading={setLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
